<template>
    <div :class="['search-locator', { 'loading': isStatus('loading'), 'has-map': isMapVisible }]">
        <div class="row">
                <div class="col-12 col-md-4 bg-dark text-light p-4">
                    <div class="filters">
                        <CpSearchLocatorFilters
                            :items="computedValue"
                            :labels="labels"
                            @ready="onReadyCount"
                            ref="filters"
                            @filter="onFilter"
                        />
                    </div>
                    <div class="list">
                        <CpSearchLocatorList
                            :api-key="mapsApiKey"
                            :center="center"
                            :infowindow="infowindow"
                            :isMapVisible="isMapVisible"
                            :items="computedValue"
                            :labels="labels"
                            @ready="onReadyCount"
                            ref="list"
                            @search="onMapSearch"
                            @select="onSelect"
                        />
                    </div>
                </div>
                <div class="col-12 col-md-8 bg-dark">
                    <div class="no-filter">
                        <div v-if="!isMobile()">
                        <CpSearchLocatorModal
                        :items="computedValue"
                        :labels="labels"
                        @hideModal="hideModal"
                        @ready="onReadyCount"
                        ref="modal"
                    />
                        </div>
                        <div :class="{ 'gray-filter': !showModal, 'brightness-filter': showModal }">
                            <CpSearchLocatorMap
                                :api-key="mapsApiKey"
                                :center="center"
                                :infowindow="infowindow"
                                :isMapVisible="isMapVisible"
                                :items="computedValue"
                                @ready="onReadyCount"
                                ref="map"
                                @search="onMapSearch"
                                @select="onSelect"
                            />
                        </div>
                    </div>


                </div>
                <div v-if="isMobile()">
                    <CpSearchLocatorModal
                        :items="computedValue"
                        :labels="labels"
                        @hideModal="hideModal"
                        @ready="onReadyCount"
                        ref="modal"
                    />
                </div>
            </div>

    </div>

</template>

<script>
import debounce from 'lodash.debounce';
import { withStatus } from '@cherrypulp/vue-utils';
import CpSearchLocatorList from './CpSearchLocatorList';
import CpSearchLocatorMap from './CpSearchLocatorMap';
import CpSearchLocatorSearch from './CpSearchLocatorSearch';
import CpSearchLocatorFilters from './CpSearchLocatorFilters';
import CpSearchLocatorModal from './CpSearchLocatorModal';
import { uuid } from '../helpers/utils';

export default {
    mixins: [ withStatus() ],

    components: {
        CpSearchLocatorList,
        CpSearchLocatorMap,
        CpSearchLocatorSearch,
        CpSearchLocatorFilters,
        CpSearchLocatorModal,
    },

    props: {
        apiKey: {
            default: null,
            type: String,
        },
        center: {
            default: true,
            type: Boolean,
        },
        infowindow: {
            default: null,
            type: String,
        },
        value: {
            default() {
                return [];
            },
            type: Array,
        },
        labels: {
            default() {
                return [];
            },
        },
    },

    data() {
        return {
            debug: false,
            isMapVisible: true,
            readyCount: 0,
            showModal: false,
        };
    },

    computed: {
        computedValue() {
            return this.value
                .filter(Boolean)
                .map((item) => {
                    item = {
                        id: uuid(),
                        ...item,
                    };

                    item.attrId = `item-${item.id}`;

                    return item;
                });
        },
        mapsApiKey() {
            if (this.$searchlocator.key) {
                return this.$searchlocator.key;
            }

            return this.apiKey;
        },
    },

    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        onMapSearch(params = null) {
            if (this.isMapVisible) {
                this.onSearch(params);
            }
        },

        onReadyCount() {
            this.readyCount++;

            if (this.readyCount > 2 && this.getStatus() !== 'ready') {
                this.onResize();
                this.setStatus('ready', true);
            }
        },

        onResize() {
            if (window.innerWidth <= 992) {
                this.isMapVisible = false;
            }
        },

        onSearch(params = null) {
            if (this.isStatus('ready')) {
                this.$emit('search', params);
            }
        },

        onSelect(item = null) {
            if (this.isStatus('ready')) {
                console.log('SearchLocator -> onSelect', item);
                this.$refs.modal.showModal(item);
                this.showModal = true;
                this.$refs.list.doSelect(item, false);
                this.$refs.map.doSelect(item, false);
                this.$emit('select', item);


            }
        },

        hideModal(){
            this.showModal = false;
        },

        onToggle() {
            this.setMapVisibility(!this.isMapVisible);
        },

        setMapVisibility(visibility, fireEvent = true) {
            if (this.isStatus('ready')) {
                this.setStatus('busy');

                // wait transitionend to set ready
                const handler = () => {
                    this.$nextTick(() => {
                        this.setStatus('ready');
                    });
                    this.$refs.list.$el.removeEventListener('transitionend', handler);
                };
                this.$refs.list.$el.addEventListener('transitionend', handler);

                this.isMapVisible = visibility;

                if (fireEvent) {
                    this.$emit('toggle', this.isMapVisible);
                }
            }
        },
        onFilter(value){
            this.$emit('input', value);
        },
    },

    mounted() {
        window.addEventListener('resize', debounce(this.onResize, 100));
        console.log('lables => ', this.labels);
        document.getElementsByClassName('search-locator-map')[0].style.height = "95vh";
    },
};
</script>

<style lang="scss">
.form-control::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: black !important;
    opacity: 1; /* Firefox */
}

.form-control:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: black !important;
}

.form-control::-ms-input-placeholder { /* Microsoft Edge */
    color: black !important;
}



@media only screen and (min-device-width: 1000px)
{
    .filters{
        //max-height: 31vh;
    }

    .list{
        max-height: 55vh;
        overflow-y: scroll;
        box-sizing: border-box;
    }

    .search-locator{
        height: 95vh;
    }
}
@media only screen and (max-device-width: 1000px)
{
    .list{
        max-height: 30vh;
        overflow-y: scroll;
        box-sizing: border-box;
    }

}
.no-filter{
    -webkit-filter: grayscale(0);
}
.gray-filter{
    -webkit-filter: grayscale(1);
}
.brightness-filter{
    -webkit-filter: grayscale(1) brightness(50%);
}
.search-locator {
    background-color: #F5F5F5;
    position: relative;

    &.loading {
        .search-locator-search,
        .search-locator-list {
            opacity: 0;
        }
    }

    &.has-map {
        .search-locator-list {
            margin-left: -100%;

            @media only screen and (min-width: 992px) {
                flex: 0 0 55%;
                margin-left: 0;
            }
        }

        .search-locator-map {
            @media only screen and (min-width: 992px) {
                flex: 0 0 45%;
            }
        }
    }
}

.search-locator-search {
    background-color: #fff;
    height: 90px;
}

.search-locator-wrapper {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    overflow: hidden;

    @media only screen and (min-width: 992px) {
    }
}

.search-locator-list,
.search-locator-map {
    position: relative;
    transition: .5s all ease-in-out;
}

.search-locator-list {
    display: block;
    flex: 0 0 100%;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: 0;
    //overflow-y: scroll;
    scroll-behavior: smooth;
}

.search-locator-map {
    background-color: #efefef;
    flex: 0 0 100%;
    height: calc(100vh - 90px);
    overflow: hidden;
    position: relative;
}
</style>
